import { RoofStructureState } from "./types";

export const defaultState = (): RoofStructureState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    roofStructures: [],
    links: {}
  };
};

export const state = defaultState();
